import { InputSize } from '@xemplo/input-utils';
import { PhoneFieldRhf } from '@xemplo/phone-field';
import { TextFieldRhf } from '@xemplo/text-field';

import { BasicDetailsSectionTestId } from './user-form-sections.const';
import * as S from './user-form-sections.styles';
import { BasicDetailsSectionProps } from './user-form-sections.types';

export function BasicDetailsSection({
  isReadOnlyNames = false,
  isEmailDisabled = false,
}: BasicDetailsSectionProps) {
  return (
    <S.Fieldset data-testid={BasicDetailsSectionTestId.Fieldset}>
      <S.Legend data-testid={BasicDetailsSectionTestId.Legend}>Basic details</S.Legend>
      <TextFieldRhf
        aria-label="First name field"
        name="firstName"
        label="First name"
        inputSize={InputSize.Spacious}
        rules={{ required: 'First name field is required' }}
        disabled={isReadOnlyNames}
      />
      <TextFieldRhf
        aria-label="Last name field"
        name="lastName"
        label="Last name"
        inputSize={InputSize.Spacious}
        rules={{ required: 'Last name field is required' }}
        disabled={isReadOnlyNames}
      />
      <TextFieldRhf
        aria-label="Email address field"
        name="emailAddress"
        label="Email"
        inputSize={InputSize.Spacious}
        rules={{
          required: 'Email address field is required',
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: 'Invalid email address',
          },
        }}
        disabled={isEmailDisabled}
      />
      <PhoneFieldRhf
        aria-label="Mobile number field"
        name="mobilePhone"
        label="Mobile number"
        rules={{ required: 'Mobile number field is required' }}
        inputSize={InputSize.Spacious}
      />
      <PhoneFieldRhf
        aria-label="Phone number field"
        name="phone"
        label="Phone"
        inputSize={InputSize.Spacious}
      />
    </S.Fieldset>
  );
}
